const selectSnackbarStore = (state: any) => state.snackbarStore

export default selectSnackbarStore
